import crossFetch from 'cross-fetch';

async function fetchWithToken(uri: RequestInfo | URL, init: RequestInit = {}) {
  return crossFetch(uri, {
    ...init,
    credentials: 'include', // Sends the JWT cookie.
  });
}

export { fetchWithToken, crossFetch as fetch };
